import 'ol/ol.css';
import { Vector as VectorLayer, Heatmap as HeatmapLayer } from 'ol/layer'
import { Vector as VectorSource } from 'ol/source'
import { Style, Circle as CircleStyle, Icon, Fill, Stroke } from 'ol/style';
import GeoJSON from "ol/format/GeoJSON";
import Point from "ol/geom/Point";
import { interpolateColors, runAnimationFeature, setMapSingleEventHandler, setSourceForGeoJSON } from 'map/OlExtension'
import { getVectorContext } from 'ol/render';
import { unByKey } from 'ol/Observable';
import { getRandomIntInclusive, hexToRgba, settingsConfig } from 'utils/commonFunc';
import defColors from 'utils/defColors';
import ApiService from 'services/ApiService';
import { ToFeatures } from 'services/GeoJsonService';
import { toLonLat, fromLonLat } from 'ol/proj';
import { Feature } from 'ol';

const heatmapSource = new VectorSource();

export default class LayerBusHeat extends HeatmapLayer {
    constructor(map) {
        super({
            source: heatmapSource,
            name: 'busHeatLayer',
            userLayer: true,
            layerIndex: 2,
            blur: 50,
            radius: 32,
            weight: function (feature) {
                if(!feature) {
                    
                }
                return feature.get('weight');
            },
            // gradient: [
            //     '#0000FF', // Blue for weight 1
            //     '#00FFFF', // Cyan for weight 2
            //     '#00FF00', // Green for weight 3
            //     '#FFFF00', // Yellow for weight 4
            //     '#FF0000'  // Red for weight 5
            // ],
            visible: false,
        });
        this.map = map;        
        this.map?.addLayer(this);
        this._isDataLoaded = false;
    }

    setHeatData = function (dateStr) {
        const layer = this;
        layer._isDataLoaded = false;      
        const sdtm = dateStr + "00";
        const edtm = dateStr + "23";
        const url = "newdashboard/busoprt/GetBusPssngrHitMapData?sdtm="+sdtm+"&edtm="+edtm;
        ApiService.get(url).then(response => {
            if (response.status === 200) {
                const data = response.data;                        
                layer.pssngr = data.pssngr;
                
                if(layer.pssngr['00']) {
                    
                    let list = layer.pssngr['00'];
                    list.sort((a, b) => a.totalCnt - b.totalCnt);
                    const maxCnt = list[list.length - 1].totalCnt;

                    for(let i = 0; i < list.length; i++) {

                        let id = list[i]['stationId'];
                        let hh = list[i]['hh'];
                        let x = list[i]['x'];
                        let y = list[i]['y'];
                        let totalCnt = list[i]['totalCnt'];
                        //let weight = totalCnt / maxCnt;
                        let weight = totalCnt < 50 ? 0.1 : (totalCnt < 100 ? 0.25 : (totalCnt < 200 ? 0.5 : (totalCnt < 300 ? 0.75 : 1)))
                        
                        const feature = new Feature({
                            geometry: new Point(fromLonLat([x, y])),
                            weight: weight
                        });
                        heatmapSource.addFeature(feature);
                    }
                    layer._isDataLoaded = true;
                }
            }
        })
    }

    changeTime = function (timeStr) {
        const layer = this;
        layer._isDataLoaded = false;
        if(layer.pssngr) {
            if(layer.pssngr[timeStr]) {
                
                let list = layer.pssngr[timeStr];
                list.sort((a, b) => a.totalCnt - b.totalCnt);
                const maxCnt = list[list.length - 1].totalCnt;

                heatmapSource.clear(true);
                for(let i = 0; i < list.length; i++) {

                    let id = list[i]['stationId'];
                    let x = list[i]['x'];
                    let y = list[i]['y'];
                    let totalCnt = list[i]['totalCnt'];
                    // let weight = totalCnt / maxCnt;
                    let weight = totalCnt < 50 ? 0.1 : (totalCnt < 100 ? 0.25 : (totalCnt < 200 ? 0.5 : (totalCnt < 300 ? 0.75 : 1)))
                    
                    const feature = new Feature({
                        geometry: new Point(fromLonLat([x, y])),
                        weight: weight
                    });
                    heatmapSource.addFeature(feature);
                }
                layer._isDataLoaded = true;
            }
        }
    }
}

export class LayerBusHeatGetOn extends HeatmapLayer {
    constructor(map) {
        super({
            source: new VectorSource(),
            name: 'busHeatLayerGetOn',
            userLayer: true,
            layerIndex: 2,
            blur: 50,
            radius: 32,
            weight: function (feature) {
                if(!feature) {
                    
                }
                return feature.get('weight');
            },
        });
        this.map = map;        
        this.map?.addLayer(this);
        this._isDataLoaded = false;
    }

    setHeatData = function (dateStr) {
        const layer = this;
        layer._isDataLoaded = false;      
        const sdtm = dateStr + "00";
        const edtm = dateStr + "23";
        const url = "newdashboard/busoprt/GetBusPssngrHitMapData?sdtm="+sdtm+"&edtm="+edtm;
        ApiService.get(url).then(response => {
            if (response.status === 200) {
                const data = response.data;                        
                layer.pssngr = data.pssngr;
                
                if(layer.pssngr['00']) {
                    
                    let list = layer.pssngr['00'];
                    list.sort((a, b) => a.inCnt - b.inCnt);
                    const maxCnt = list[list.length - 1].inCnt;

                    const geojsonObject = {
                        type: 'FeatureCollection',
                        features: [],
                    };

                    for(let i = 0; i < list.length; i++) {

                        let id = list[i]['stationId'];
                        let hh = list[i]['hh'];
                        let x = list[i]['x'];
                        let y = list[i]['y'];
                        let inCnt = list[i]['inCnt'];
                        let weight = inCnt / maxCnt;
                        
                        let feature = {
                            id: id,
                            type: 'Feature',
                            geometry: {
                              type: 'Point',
                              coordinates: fromLonLat([x, y]),
                            },
                            properties: {
                              weight: weight,
                            },
                        };
                        
                        geojsonObject.features.push(feature);                        
                    }

                    const vectorSource = new VectorSource({
                        features: new GeoJSON().readFeatures(geojsonObject), 
                    });                    
                    layer.setSource(vectorSource)
                    layer.changed();
                    layer._isDataLoaded = true;
                    console.log('setHeatData')
                }
            }
        })
    }

    changeTime = function (timeStr) {
        const layer = this;
        layer._isDataLoaded = false;
        if(layer.pssngr) {
            if(layer.pssngr[timeStr]) {
                
                let list = layer.pssngr[timeStr];
                list.sort((a, b) => a.inCnt - b.inCnt);
                const maxCnt = list[list.length - 1].inCnt;

                const geojsonObject = {
                    type: 'FeatureCollection',
                    features: [],
                };

                for(let i = 0; i < list.length; i++) {

                    let id = list[i]['stationId'];
                    let x = list[i]['x'];
                    let y = list[i]['y'];
                    let inCnt = list[i]['inCnt'];
                    let weight = inCnt / maxCnt;
                    
                    if(timeStr == '01' || timeStr == '03' || timeStr == '05') {
                        weight = 0.1;
                    }
                    
                    let feature = {
                        id: id,
                        type: 'Feature',
                        geometry: {
                            type: 'Point',
                            coordinates: fromLonLat([x, y]),
                        },
                        properties: {
                            weight: weight,
                        },
                    };

                    geojsonObject.features.push(feature);
                }

                const vectorSource = new VectorSource({
                    features: new GeoJSON().readFeatures(geojsonObject), 
                });
                layer.setSource(vectorSource)
                layer.changed();
                layer._isDataLoaded = true;
                console.log('changeTime', timeStr)
            }
        }
    }
}

export class LayerBusHeatGetOff extends HeatmapLayer {
    constructor(map) {
        super({
            source: new VectorSource(),
            name: 'busHeatLayerGetOff',
            userLayer: true,
            layerIndex: 2,
            blur: 50,
            radius: 32,
            weight: function (feature) {
                if(!feature) {
                    
                }
                return feature.get('weight');
            },
        });
        this.map = map;        
        this.map?.addLayer(this);
        this._isDataLoaded = false;
    }

    setHeatData = function (dateStr) {
        const layer = this;
        layer._isDataLoaded = false;      
        const sdtm = dateStr + "00";
        const edtm = dateStr + "23";
        const url = "newdashboard/busoprt/GetBusPssngrHitMapData?sdtm="+sdtm+"&edtm="+edtm;
        ApiService.get(url).then(response => {
            if (response.status === 200) {
                const data = response.data;                        
                layer.pssngr = data.pssngr;
                
                if(layer.pssngr['00']) {
                    
                    let list = layer.pssngr['00'];
                    list.sort((a, b) => a.outCnt - b.outCnt);
                    const maxCnt = list[list.length - 1].outCnt;

                    const geojsonObject = {
                        type: 'FeatureCollection',
                        features: [],
                    };

                    for(let i = 0; i < list.length; i++) {

                        let id = list[i]['stationId'];
                        let hh = list[i]['hh'];
                        let x = list[i]['x'];
                        let y = list[i]['y'];
                        let outCnt = list[i]['outCnt'];
                        let weight = outCnt / outCnt;
                        
                        let feature = {
                            id: id,
                            type: 'Feature',
                            geometry: {
                              type: 'Point',
                              coordinates: fromLonLat([x, y]),
                            },
                            properties: {
                              weight: weight,
                            },
                        };
                        
                        geojsonObject.features.push(feature);                        
                    }

                    const vectorSource = new VectorSource({
                        features: new GeoJSON().readFeatures(geojsonObject), 
                    });                    
                    layer.setSource(vectorSource)
                    layer.changed();
                    layer._isDataLoaded = true;
                    console.log('setHeatData')
                }
            }
        })
    }

    changeTime = function (timeStr) {
        const layer = this;
        layer._isDataLoaded = false;
        if(layer.pssngr) {
            if(layer.pssngr[timeStr]) {
                
                let list = layer.pssngr[timeStr];
                list.sort((a, b) => a.outCnt - b.outCnt);
                const maxCnt = list[list.length - 1].outCnt;

                const geojsonObject = {
                    type: 'FeatureCollection',
                    features: [],
                };

                for(let i = 0; i < list.length; i++) {

                    let id = list[i]['stationId'];
                    let x = list[i]['x'];
                    let y = list[i]['y'];
                    let outCnt = list[i]['outCnt'];
                    let weight = outCnt / maxCnt;
                    
                    if(timeStr == '01' || timeStr == '03' || timeStr == '05') {
                        weight = 0.1;
                    }
                    
                    let feature = {
                        id: id,
                        type: 'Feature',
                        geometry: {
                            type: 'Point',
                            coordinates: fromLonLat([x, y]),
                        },
                        properties: {
                            weight: weight,
                        },
                    };

                    geojsonObject.features.push(feature);
                }

                const vectorSource = new VectorSource({
                    features: new GeoJSON().readFeatures(geojsonObject), 
                });
                layer.setSource(vectorSource)
                layer.changed();
                layer._isDataLoaded = true;
                console.log('changeTime', timeStr)
            }
        }
    }
}